import { TNoticeExtractionPollFailure } from './resolveNoticeExtractionPollOutcome';

export const getNoticeExtractionFailureMessage = (failure: TNoticeExtractionPollFailure, fileName: string): string => {
  switch (failure) {
    case 'extraction':
      return `Notice extraction failed for ${fileName}. Please try uploading the notice again.`;
    case 'status-unavailable':
      return `Could not check notice extraction status for ${fileName}. Reload the page to retry.`;
    case 'stalled':
      return `Notice extraction for ${fileName} is taking longer than expected. Reload the page to check again later.`;
  }
};
